import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GROWTH_LEGAL_DISCLAIMER_UPDATE = createFcmConfig('growth_legal_disclaimer_update', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
